import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Cart from './pages/Cart';

function App() {
  return (
    <div className="App">
       <Navbar />

       <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/cart' element={<Cart />} />
       </Routes>
    </div>
  );
}

export default App;
